import { useCapitalGlobalProposalStep2Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step2-form.context';
import {
  CAPITAL_GLOBAL_PROPOSAL_PREMIUM_PERIODICITY_ALERT,
  getCapitalGlobalProposalPremiumAmountLabel,
} from '@/features/proposals/components/capital-global/steps/constants/capital-global-proposal-payment-step.constants';
import { PremiumCard } from '@/features/quotes/components/premium-card.component';
import { Text } from '@noorden-insurtech/alba-design-system';

export function CapitalGlobalProposalPaymentPremiumSection() {
  const {
    form,
    isViewMode,
    shouldShowStep2FieldErrors,
    annualPremiumAmount,
    premiumPeriodicityOptions,
    premiumPeriodicityCatalog,
    isSubmitting,
  } = useCapitalGlobalProposalStep2Form();

  return (
    <div className='flex flex-col gap-6 w-full'>
      <Text className='text-base text-alba-black-500'>
        Informações de Pagamento
      </Text>
      <div className='flex flex-col gap-8 w-full'>
        <div className='w-full max-w-[605px]'>
          <form.AppField
            name='premiumPeriodicity'
            validators={{
              onChange: ({ value, fieldApi }) => {
                if (isViewMode) return undefined;
                if (!shouldShowStep2FieldErrors(fieldApi)) return undefined;
                if (!String(value || '').trim()) {
                  return 'Selecione a periodicidade do prêmio';
                }
                return undefined;
              },
            }}
            children={field => (
              <field.SelectField
                label='Periodicidade do Prêmio'
                placeholder='Selecione a periodicidade'
                required
                options={premiumPeriodicityOptions}
                disabled={isViewMode || isSubmitting}
              />
            )}
          />
        </div>
        <form.Subscribe
          selector={state => state.values.premiumPeriodicity}
          children={premiumPeriodicity => {
            const hasPeriodicity =
              String(premiumPeriodicity || '').trim() !== '';
            return (
              <div className='flex flex-col items-stretch w-full'>
                <PremiumCard
                  title='Prêmio'
                  value={getCapitalGlobalProposalPremiumAmountLabel(
                    String(premiumPeriodicity || ''),
                    annualPremiumAmount,
                    premiumPeriodicityCatalog
                  )}
                  showAlert={!hasPeriodicity}
                  alertMessage={CAPITAL_GLOBAL_PROPOSAL_PREMIUM_PERIODICITY_ALERT}
                />
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}
